module.exports = __webpack_public_path__ + "img/icon-start-over.678c6cfe.svg";